export default {
    queryQuestioncsList:
        "/gateway/manageBedrock/free/questioncs/queryQuestioncsList", // 安全培训列表查询
    selectLatestCompactDetail:
        "/gateway/huilian/compact/selectLatestCompactDetail", // 最新签订合同详情
    // queryCustomerInfo: "/gateway/huilian/customermanagercs/queryCustomerInfo", //客户信息
    queryCustomerInfo: "/gateway/huilianCust/logincs/queryCustomerInfo",
};



// WEBPACK FOOTER //
// ./src/customerServiceCenter/index/api.js